import { cn } from "@/lib/utils";
import { PERMISSION_DENIED_MESSAGE } from "@/lib/convex-errors";

export function PermissionDenied({
  message = PERMISSION_DENIED_MESSAGE,
  variant = "page",
  className,
}) {
  if (variant === "inline") {
    return (
      <p className={cn("text-sm text-muted-foreground", className)}>{message}</p>
    );
  }

  return (
    <div
      className={cn(
        "flex min-h-[40vh] flex-col items-center justify-center gap-4 p-8",
        className,
      )}
    >
      <p className="max-w-md text-center text-sm text-muted-foreground">
        {message}
      </p>
    </div>
  );
}
